import { trpc } from '@/shared/api/trpc';

// The conversation on one ticket, oldest first. Server-scoped: a reporter only
// reaches their own tickets, management reaches any ticket in the org.
//
// Its own query key rather than a field on `byId` — a new comment must not
// force the whole ticket to refetch. `enabled` defers the fetch until the
// thread is actually visible (drawer opened / row expanded).
export const useTicketComments = (ticketId: string | null, enabled = true) =>
  trpc.support.commentList.useQuery(
    { ticketId: ticketId ?? '' },
    { enabled: enabled && Boolean(ticketId) }
  );
